import { useMutation } from '@tanstack/react-query';
import type { SuggestPatientResponseT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchCareSuggestPatient } from '../api/suggestPatient.js';

export function useCareSuggestPatientMutation() {
  return useMutation({
    mutationKey: ['care', 'patients', 'suggest'],
    mutationFn: async (): Promise<SuggestPatientResponseT> => {
      return await fetchCareSuggestPatient();
    },
    meta: {
      toast: {
        title: 'Could not suggest next patient',
        description: 'Patient suggestion could not be fetched.',
      },
    },
  });
}
